import { AxiosClient } from '@/app/shared/services';

const state = {
    settingsList: {
        list: [],
        isLoading: false,
    },
    currentSettings: {
        settings: {
            name: '',
            description: '',
            count_sms_ban: '',
            count_call_ban: '',
            call_chain_account: { name: '' , is_used: true},
            call_instant_account: { name: '' , is_used: true},
            sms_chain_account: { name: '' , is_used: true},
            sms_instant_account: { name: '' , is_used: true},
            max_workers: null,
            postbacks_enabled: false,
        },
        isLoading: false,
    },
    vkInfo: {
        client_secret: '',
        client_id: '',
        accounts: [],
    },
    vkInfos: [],
};

const getters = {
    SETTINGS_LOADING: (state) => state.settingsList.isLoading,
    SETTINGS_LIST: (state) => state.settingsList.list,

    CURRENT_SETTINGS: (state) => state.currentSettings.settings,
    CURRENT_SETTINGS_LOADING: (state) => state.currentSettings.isLoading,
    VK_INFO: (state) => state.vkInfo,
    VK_INFOS: (state) => state.vkInfos,
};

const mutations = {
    SET_SETTINGS_LIST: (state, settings) => {
        state.settingsList.list = settings;
    },
    SET_SETTINGS_LOADING: (state, isLoading) => {
        state.settingsList.isLoading = isLoading;
    },
    SET_CURRENT_SETTINGS: (state, settings) => {
        state.currentSettings.settings = settings;
    },
    SET_CURRENT_SETTINGS_LOADING: (state, isLoading) => {
        state.currentSettings.isLoading = isLoading;
    },
    SET_VK_INFO: (state, vkInfo) => {
        state.vkInfo = vkInfo;
    },
    SET_VK_INFOS: (state, vkInfos) => {
        state.vkInfos = vkInfos;
    },
    SET_CURRENT_SETTINGS_DEFAULT: (state) => {
        state.currentSettings.settings = {
            name: '',
            description: '',
            count_sms_ban: '',
            count_call_ban: '',
            call_chain_account: { name: '' , is_used: true},
            call_instant_account: { name: '' , is_used: true},
            sms_chain_account: { name: '' , is_used: true},
            sms_instant_account: { name: '' , is_used: true},
            max_workers: null,
            postbacks_enabled: false,
        };
    },
};

const actions = {
    GET_SETTINGS_LIST: (context, params) => {
        context.commit('SET_SETTINGS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/settings/get_list', {params})
                .then((response) => {
                    context.commit('SET_SETTINGS_LIST', response.data);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_SETTINGS_LOADING', false);
                    context.commit("SET_CURRENT_SETTINGS_DEFAULT");
                });
        });
    },

    GET_SETTINGS_BY_ID: (context, settings_id) => {
        context.commit('SET_CURRENT_SETTINGS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/settings/get/${settings_id}`)
                .then((response) => {
                    context.commit('SET_CURRENT_SETTINGS', response.data);
                    resolve(response.data);
                })
                .catch(() => reject())
                .finally(() => context.commit('SET_CURRENT_SETTINGS_LOADING', false));
        });
    },

    UPDATE_SETTINGS: (context, settings) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/settings/update/${settings.id}`, settings)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                    context.commit("SET_CURRENT_SETTINGS_DEFAULT");
                });
        });
    },

    UPDATE_API_KEY: (context) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/admin/update_api_key')
                .then((data) => {
                    context.commit("SET_AUTH_USER", data.data);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                    context.commit("SET_CURRENT_SETTINGS_DEFAULT");
                });
        });
    },

    GENERATE_DOCS: (context) => {
        return new Promise((resolve, reject) => {
            AxiosClient.post('/admin/generate_docs')
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    CHANGE_USAGE: (context, formId) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/vk/change_usage/${formId}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                });
        });
    },

    GET_VK_INFO_BY_ID: (context, settings_id) => {
        context.commit('SET_CURRENT_SETTINGS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/vk/get/${settings_id}`)
                .then((response) => {
                    context.commit('SET_CURRENT_SETTINGS', response.data.settings);
                    context.commit('SET_VK_INFOS', response.data.vkInfo);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => context.commit('SET_CURRENT_SETTINGS_LOADING', false));
        });
    },

    UPDATE_VK_SETTINGS: (context, id) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/vk/update/${id}`)
                .then((response) => {
                    context.commit('SET_CURRENT_SETTINGS', response.data.settings);
                    context.commit('SET_VK_INFOS', response.data.vkInfo);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                });
        });
    },

    CREATE_VK_SETTINGS: (context, params) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/vk/create', params)
                .then((response) => {
                    context.commit('SET_CURRENT_SETTINGS', response.data.settings);
                    context.commit('SET_VK_INFOS', response.data.vkInfo);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                });
        });
    },

    DELETE_VK_SETTINGS: (context, id) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/vk/delete/${id}`)
                .then((response) => {
                    context.commit('SET_CURRENT_SETTINGS', response.data.settings);
                    context.commit('SET_VK_INFOS', response.data.vkInfo);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false);
                });
        });
    },

    CREATE_SETTINGS: (context, settings) => {
        context.commit("SET_CURRENT_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/settings/create", settings)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => {
                    context.commit("SET_CURRENT_SETTINGS_LOADING", false)
                    context.commit("SET_CURRENT_SETTINGS_DEFAULT")
                });
        });
    },

    DELETE_SETTINGS: (context, settings_id) => {
        context.commit("SET_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/settings/delete/${settings_id}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_SETTINGS_LOADING", false));
        });
    },

    SET_DEFAULT_SETTINGS: (context, settings_id) => {
        context.commit("SET_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/settings/set_default/${settings_id}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_SETTINGS_LOADING", false));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
